import React, { useState } from 'react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { authExtrasAPI } from '../services/api';
import { Button } from './ui/button';
import { Envelope, X, CheckCircle } from '@phosphor-icons/react';

export default function EmailVerifyBanner() {
  const { user, refreshUser } = useAuth();
  const { t } = useTheme();
  const [sending, setSending] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Hide for admins, verified users, or if user is null
  if (!user || user.role === 'admin' || user.email_verified || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await authExtrasAPI.sendVerificationEmail(user.email);
      toast.success('Verification email sent! Check your inbox.');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not send email');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-5 pt-3" data-testid="email-verify-banner">
      <div
        className="flex items-center justify-between gap-3 flex-wrap p-3 rounded-xl backdrop-blur"
        style={{
          background: 'rgba(245, 158, 11, 0.08)',
          border: '1px solid rgba(245, 158, 11, 0.28)',
        }}
      >
        <div className="flex items-center gap-2.5 flex-1 min-w-0">
          <Envelope className="w-4 h-4 text-[#F59E0B] flex-shrink-0" weight="fill" />
          <p className="text-xs sm:text-sm min-w-0" style={{ color: t.textPrimary }}>
            <span className="font-semibold">Verify your email</span>
            <span className="hidden sm:inline" style={{ color: t.textMutedNew }}>{' '}— unlock invoices, splits and payouts.</span>
          </p>
        </div>
        <div className="flex items-center gap-1.5 flex-shrink-0">
          <Button size="sm" onClick={resend} disabled={sending} className="bg-[#F59E0B] hover:bg-[#D97706] text-black rounded-lg font-semibold text-xs h-7 px-3" data-testid="resend-verification-btn">
            {sending ? 'Sending…' : 'Resend'}
          </Button>
          <button
            onClick={() => setDismissed(true)}
            className="p-1 hover:opacity-80"
            style={{ color: t.textMutedNew }}
            data-testid="dismiss-verify-banner"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
